import { useState, useEffect } from "react";
import { Form } from "antd";
import { getApi, postApi } from "../../services/api";
import { toast } from "react-toastify";

const useClassRooms = () => {
	const [searchTerm, setSearchTerm] = useState("");
	const [filterTeacher, setFilterTeacher] = useState("");
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalType, setModalType] = useState("add");
	const [setFormType] = useState("course");
	const [selectedClassroom, setSelectedClassroom] = useState(null);
	const [form] = Form.useForm();
	const [teachers] = useState([]);
	const [classrooms, setClassrooms] = useState([]);

	useEffect(() => {
		// Fetch data from the backend API
		const fetchClassrooms = async () => {
			try {
				const response = await getApi("/classrooms");
				const data = response.map((classroom) => ({
					id: classroom._id,
					title: classroom?.courseId?.name, // Extract course name
					teacher: classroom?.userId?.fullName, // Extract teacher name
					sessionTime: classroom.sessionTime, //extract the session time
					schedules: classroom?.courseId?.schedule,
					assignedAt: new Date(
						classroom.assignedAt
					).toLocaleDateString(), // Format assignedAt date
				}));
				setClassrooms(data);

				// toast.success("Classrooms fetched successfully!");
				// // Extract unique courses and teachers
				// const uniqueCourses = [...new Set(data.map((item) => item.title))];
				// const uniqueTeachers = [...new Set(data.map((item) => item.teacher))];
				// const SessionTimes = [...new Set(data.map((item) => new Date(item.sessionTimes).toLocaleDateString()))];

				// setAssignedAt(assignedAt)
				// setSessionTimes(SessionTimes)
				// setCourses(uniqueCourses);
				// setTeachers(uniqueTeachers);
			} catch (error) {
				// toast.error("Failed to fetch classrooms:", error.message);
			}
		};

		fetchClassrooms().then(() => console.log("been here"));
	}, []);

	const fetchClassroomSchedule = async (classroomId) => {
		try {
			const schedules = await getApi(
				`/classrooms/schedule/${classroomId}`
			);
			return schedules;
		} catch (error) {
			console.error(error);
			// toast.error("Failed to fetch classroom schedule.");
			return [];
		}
	};

	const showModal = async (type, formType, classroom = null) => {
		if (type === "createMeeting") {
			const meeting = await postApi("/meeting/createBreakoutRoom");
			if (meeting?.error) {
				console.error(
					"There was an error creating a meeting",
					meeting.message
				);
				toast.error("Failed to create meeting.");
				return;
			}
			window.open(meeting.meetingUrl, "_blank");
			// TODO: Show success modal or something
			toast.success("Meeting created successfully!");
			return;
		}
		const schedules = await fetchClassroomSchedule(classroom.id);
		setModalType(type);
		setFormType(formType);
		setSelectedClassroom({ ...classroom, schedules });

		// if (type === "view") {
		// 	form.setFieldsValue({
		// 		...course,
		// 		schedules,
		// 	});
		// } else {
		// 	form.resetFields();
		// }

		setIsModalVisible(true);
	};

	const handleModalConfirm = () => {
		form.validateFields().then((values) => {
			// const course = {
			// 	...values,
			// 	id: selectedClassroom
			// 		? selectedClassroom.id
			// 		: `course-${Date.now()}`,
			// 	sessionTimes: values.sessionTimes || [],
			// };

			setIsModalVisible(false);
			toast.success("Changes saved successfully!");
		});
	};

	const handleModalCancel = () => {
		setIsModalVisible(false);
	};

	// Filter the courses based on searchTerm, filterTeacher, and filterDuration
	const filteredClassrooms = classrooms.filter((classroom) => {
		const matchesSearchTerm = searchTerm
			? classroom.title.toLowerCase().includes(searchTerm.toLowerCase())
			: true;
		const matchesTeacher = filterTeacher
			? classroom.teacher === filterTeacher
			: true;
		return matchesSearchTerm && matchesTeacher;
	});

	return {
		searchTerm,
		setSearchTerm,
		filterTeacher,
		setFilterTeacher,
		isModalVisible,
		modalType,
		selectedClassroom,
		setSelectedClassroom,
		form,
		teachers,
		filteredClassrooms,
		showModal,
		handleModalConfirm,
		handleModalCancel,
	};
};

export default useClassRooms;
